import React, { useEffect, useCallback, useState } from 'react';
import {
    Col,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ListGroup,
    ListGroupItem,
    Card,
    Row,
    Container,
} from 'reactstrap';
import api from '../../services/api';
import { toast } from 'react-toastify';

export default function ModalViewSeniors(props) {
    const { modal, toggleModal, giver, isModalOpen, groupId } = props;
    const [id, setId] = useState(null);
    const [giverData, setGiverData] = useState({});
    const [receiversData, setReceiversData] = useState([]);
    useEffect(() => {
        if (isModalOpen) {
            setReceiversData(giver.receivers);
            setId(groupId);
            setGiverData(giver);
        }
    }, [giver, isModalOpen, groupId]);

    const removeSenior = useCallback(
        (member) => {
            api.patch(`/ro.team.removeGiverToReceiver/${id}`, {
                givid: giverData.id,
                recid: member.id,
            })
                .then((response) => {
                    const index = receiversData.indexOf(member);
                    const result = receiversData.splice(index, 1);
                    setReceiversData(result);
                    toast.success(`${member.name} was removed!`);
                })
                .catch((err) => {
                    toast.error(err.response.data.message);
                });
        },
        [receiversData, giverData.id, id]
    );

    return (
        <Modal isOpen={modal} toggle={toggleModal}>
            <ModalHeader toggle={toggleModal}>
                {giver.name}'s Seniors
            </ModalHeader>
            <ModalBody>
                <Container fluid>
                    <Row>
                        <Col lg="12">
                            <Card className="main-card mb-3">
                                <ListGroup flush>
                                    {receiversData &&
                                        receiversData.map((member) => (
                                            <ListGroupItem key={member.id}>
                                                <div className="widget-content p-0">
                                                    <div className="widget-content-wrapper">
                                                        <div className="widget-content-left mr-3">
                                                            <div className="placeholder-avatar">
                                                                {member.name
                                                                    ? member.name.charAt(
                                                                          0
                                                                      )
                                                                    : member.email.charAt(
                                                                          0
                                                                      )}
                                                            </div>
                                                        </div>
                                                        <div className="widget-content-left">
                                                            <div className="widget-heading">
                                                                {member.name &&
                                                                    member.name}
                                                            </div>
                                                            <div className="widget-subheading">
                                                                {member.email}
                                                            </div>
                                                            <div className="widget-subheading">
                                                                {member.phone &&
                                                                    member.phone}
                                                            </div>
                                                        </div>
                                                        <div className="widget-content-right">
                                                            <Button
                                                                className="mb-2 mr-2 btn-icon btn-icon-only btn-pill"
                                                                outline
                                                                color="warning"
                                                                onClick={() => {
                                                                    removeSenior(
                                                                        member
                                                                    );
                                                                }}
                                                            >
                                                                <i className="pe-7s-trash btn-icon-wrapper">
                                                                    {' '}
                                                                </i>
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ListGroupItem>
                                        ))}
                                </ListGroup>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </ModalBody>
        </Modal>
    );
}
